import { takeLatest } from "redux-saga/effects";
import { handleGetUser } from "./handlers/user";
import { handleGetCompare } from "./handlers/compare";
import { handleGetSaveLater } from "./handlers/savelater";
import { handleGetWishList } from "./handlers/wishlist";
import {
	handleGetProducts,
	handleGetProduct,
	handleGetProductTotal,
} from "./handlers/products";
import { handleGetAttributes } from "./handlers/attributes";

import { getUser_ } from "../ducks/userSlice";
import { getCompare_ } from "../ducks/compareSlice";
import { getWishList_ } from "../ducks/whishListSlice";
import {
	getProducts,
	getProduct,
	getTotalProducts,
} from "../ducks/productSlice";
import { getAttributes } from "../ducks/attributesSlice";
import { getSaveLater_ } from "../ducks/saveLaterSlice";

export function* watcherSaga() {
	yield takeLatest(getSaveLater_.type, handleGetSaveLater);
	yield takeLatest(getCompare_.type, handleGetCompare);
	yield takeLatest(getWishList_.type, handleGetWishList);
	yield takeLatest(getUser_.type, handleGetUser);
	yield takeLatest(getProducts.type, handleGetProducts);
	yield takeLatest(getProduct.type, handleGetProduct);
	yield takeLatest(getAttributes.type, handleGetAttributes);
	yield takeLatest(getTotalProducts.type, handleGetProductTotal);
}
